// ============================================
// INTEGRAÇÃO COM MAILCHIMP VIA SUPABASE
// ============================================

import { supabase } from '@/integrations/supabase/client';

/**
 * Inscreve um usuário no Mailchimp através da Edge Function do Supabase
 */
export const subscribeToMailchimp = async (
  grau_calvicie: string,
  data: {
    nome: string;
    email: string;
    grau_calvicie: string;
  }
) => {
  console.log('🚀 Iniciando inscrição no Mailchimp');
  console.log('📋 Dados:', { grau_calvicie, nome: data.nome, email: data.email });
  
  try {
    console.log('📡 Chamando edge function mailchimp-subscribe...');
    
    const { data: result, error } = await supabase.functions.invoke('mailchimp-subscribe', {
      body: {
        grau_calvicie,
        nome: data.nome,
        email: data.email,
      },
    });

    console.log('📥 Resposta da edge function:', { result, error });

    if (error) {
      console.error('❌ Erro ao inscrever no Mailchimp:', error);
      console.error('❌ Detalhes do erro:', JSON.stringify(error, null, 2));
      return null;
    }

    console.log('✅ Inscrito com sucesso no Mailchimp:', result);
    return result;
  } catch (error) {
    console.error('❌ Erro ao conectar com Mailchimp:', error);
    console.error('❌ Stack:', error instanceof Error ? error.stack : 'N/A');
    return null;
  }
};
